import { render, staticRenderFns } from "./SingletonLogin.vue?vue&type=template&id=538bf4f0&"
import script from "./SingletonLogin.vue?vue&type=script&lang=js&"
export * from "./SingletonLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports